/** Box 11 of the ICS 203-CG, the Resources Unit Leader's Prepared by. */

import type React from 'react';

import { ICS203_BOX_LABELS } from './ics203BoxLabels';
import { IcsPreparedByBox } from './IcsPreparedByBox';

export const Ics203SignatureBox: React.FC<{ periodNumber: number }> = ({
  periodNumber,
}) => (
  <IcsPreparedByBox
    baseId="ICS_203"
    periodNumber={periodNumber}
    boxLabel={ICS203_BOX_LABELS.preparedBy}
    testId="ics203-signature-box"
  />
);

export default Ics203SignatureBox;
